import Vue from 'vue';
import AccountPackageSelector from './account-package-selector/AccountPackageSelector.vue';
import AccountCard from './account-package-selector/components/AccountCard.vue';
import MiniCard from './account-package-selector/components/MiniCard.vue';
import OpenAccountModal from './account-package-selector/components/OpenAccountModal.vue';
import AccountCompare from './account-package-selector/components/AccountCompare.vue';
import StepList from './account-package-selector/components/StepList.vue';
import StoreButton from './account-package-selector/components/StoreButton.vue';
import BadgeList from './account-package-selector/components/BadgeList.vue';
import BadgeListItem from './account-package-selector/components/BadgeListItem.vue';
import RcoForeignCurrencyAccountPickerButton from '../common/components/rco-foreign-currency-account-picker-button/rco-foreign-currency-account-picker-button.vue';
import QrCode from '../common/components/qr-code/qr-code.vue';

Vue.component('AccountPackageSelector', AccountPackageSelector);
Vue.component('AccountCard', AccountCard);
Vue.component('MiniCard', MiniCard);
Vue.component('OpenAccountModal', OpenAccountModal);
Vue.component('AccountCompare', AccountCompare);
Vue.component('StepList', StepList);
Vue.component('StoreButton', StoreButton);
Vue.component('BadgeList', BadgeList);
Vue.component('BadgeListItem', BadgeListItem);
Vue.component('RcoForeignCurrencyAccountPickerButton', RcoForeignCurrencyAccountPickerButton);
Vue.component('QrCode', QrCode);
